// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmDeletePrice/ConfirmDeletePrice.css
// module id = 1630
// module chunks = 0